package dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun ApiRoute13Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/fullstack/ApiRoute13.md", mapOf())) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("api-routes") }) {
                org.jetbrains.compose.web.dom.Text("API routes")
            }
            dev.bitspittle.droidconSf24.components.widgets.Code("""// Frontend
val scope = rememberCoroutineScope()
Button(onClick = {
    val msg = ContactMeMessage(
        firstName, lastName, subject, message
    )
    scope.launch {
        window.api.post(
            "contact-me",
            body = Json.encodeToString(msg)
                .encodeToByteArray()
        )
    }
}) { Text("Send Message") }
""", "kotlin 0|4-6|2,7-13|0 <hide-vertical-scrollbar,apifrontend> [api-frontend]")
        }
    }
}
